import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Api } from '../providers';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/mergeMap';
import { SendMessage } from '../../models/messenger.model';

/*
  Generated class for the MessengerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class MessengerProvider {
  constructor(private http: HttpClient, private api: Api) {}

  getAllMessages(): Observable<any> {
    return this.api.get('messages/allShort', {}).map(res => {
      return res;
    });
  }

  getAllSearch(
    query: string,
    pageNumber: number,
    pageSize: number
  ): Observable<any> {
    return this.api
      .get(
        'messages/allShort?search=' +
          query +
          '&pageNumber=' +
          pageNumber +
          '&pageSize=' +
          pageSize,
        {}
      )
      .map(res => {
        return res;
      });
  }
  getNewMessagesFromUser(): Observable<any> {
    return this.api.post('messages/check', {}).map(res => {
      return res;
    });
  }

  getAllMessagesFromUser(
    userId: string,
    pageNumber: number,
    pageSize: number
  ): Observable<any> {
    return this.api
      .get('messages/all', {
        userUuid: userId,
        pageNumber: pageNumber,
        pageSize: pageSize,
      })
      .map(res => {
        return res;
      });
  }

  getContacts(query, pageNumber, pageSize): Observable<any> {
    return this.api
      .post(
        `user/getContacts/paginated?search=${query}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
        {
          search: query,
          pageNumber: pageNumber,
          pageSize: pageSize,
        }
      )
      .map(res => {
        return res;
      });
  }

  sendMessage(body: SendMessage): Observable<any> {
    return this.api.post('messages/send', body).map(res => {
      return res;
    });
  }

  addNote(contactId: string, note: string): Observable<any> {
    return this.api
      .post('notes/add?contactUuid=' + contactId, { note: note })
      .map(res => {
        return res;
      });
  }

  removeNote(contactId: string, note: string): Observable<any> {
    return this.api
      .post('notes/remove?contactUuid=' + contactId, { note: note })
      .map(res => {
        return res;
      });
  }

  getAllNotes(query, pageNUmber, pageSize): Observable<any> {
    return this.api
      .get('notes/findAll', {
        search: query,
        pageNumber: pageNUmber,
        pageSize: pageSize,
      })
      .map(res => {
        return res;
      });
  }

  getAllNotesFromUser(contactId: string): Observable<any> {
    return this.api.post('notes/find?contactUuid=' + contactId, {}).map(res => {
      return res;
    });
  }

  getFavoritesPaginated(query, pageNumber, pageSize): Observable<any> {
    return this.api
      .post(
        `user/getFavorites/paginated?search=${query}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
        {}
      )
      .map(res => {
        return res;
      });
  }

  addFavorite(userId: string): Observable<any> {
    return this.api.post('user/addFavorite', { user: userId }).map(res => {
      return res;
    });
  }

  removeFavorite(userId: string): Observable<any> {
    return this.api.post('user/removeFavorite', { user: userId }).map(res => {
      return res;
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/messenger/messenger.ts